"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateInvoice = class CreateInvoice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoiceKind;
    onInvoice_kind(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceKind");
    }
    invoiceType;
    onInvoice_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceType");
    }
    registerEntry;
    onRegister_entry(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("registerEntry");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    titles;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('get_invoice_template', {
            parameters: {
                invoice_kind: this.invoiceKind,
                invoice_type: this.invoiceType,
                register_entry: this.registerEntry
            }
        }).then(data => new this.$fn.Resource(data, {
            billing_period: data.billing_period || { start: null, end: null },
        }));
    }
    formContext;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'titles', 'formId', 'item', 'formContext', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                titles: {
                    incoming: this.$fn.pgettext("Invoice", "Create Incoming Invoice"),
                    outgoing: this.$fn.pgettext("Invoice", "Create Outgoing Invoice"),
                },
                formId: null,
                item: null,
                formContext: {},
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get incomingInvoice() {
        if (this.loaded) {
            return this.invoiceKind === 'incoming';
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.titles[this.invoiceKind],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4348_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_reloadSlickgrid_4354_getActionArgs($event) {
        return {
            grid: "invoices",
        };
    }
    async evh_2248226175642056_deleted(event, scope) {
        return await this.actions.evh_2248226175642056_deleted.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_4358_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_1040167445267876_navigate_4360_getActionArgs($event) {
        return {
            location: {
                name: "app.invoice",
                params: {
                    id: $event.data.id,
                },
            },
        };
    }
    async act_1040167445267876_crud_4356_getActionArgs($event) {
        return {
            objectType: "invoice",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_4362_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4348 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4348_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4347 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4348,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4347],
        });
        const act_2248226175642056_closeModal_4350 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_4349 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_4350,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4349],
        });
        const act_2248226175642056_closeModal_4352 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_deleted_4351 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_4352,
            event: "deleted",
            displayName: "closeModal",
        });
        const act_2248226175642056_reloadSlickgrid_4354 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_4354_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_deleted_4353 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_4354,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_2248226175642056_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_deleted_4351, evh_2248226175642056_deleted_4353],
        });
        const act_1040167445267876_closeModal_4358 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_4358_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4357 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_4358,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_navigate_4360 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_4360_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4359 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_4360,
            event: "success",
            displayName: "navigate",
        });
        const act_1040167445267876_crud_4356 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_4356_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_4357, evh_1040167445267876_success_4359],
        });
        const evh_1040167445267876_submit_4355 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_4356,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4355],
        });
        const act_1419464017721962_closeModal_4362 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_4362_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4361 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_4362,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4361],
        });
        return {
            act_7315092382398562_closeModal_4348,
            evh_7315092382398562_close_4347,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_4350,
            evh_2248226175642056_close_4349,
            evh_2248226175642056_close,
            act_2248226175642056_closeModal_4352,
            evh_2248226175642056_deleted_4351,
            act_2248226175642056_reloadSlickgrid_4354,
            evh_2248226175642056_deleted_4353,
            evh_2248226175642056_deleted,
            act_1040167445267876_closeModal_4358,
            evh_1040167445267876_success_4357,
            act_1040167445267876_navigate_4360,
            evh_1040167445267876_success_4359,
            act_1040167445267876_crud_4356,
            evh_1040167445267876_submit_4355,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_4362,
            evh_1419464017721962_clickPreventStop_4361,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_crud_4356,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "outgoing",
    }),
    __metadata("design:type", String)
], CreateInvoice.prototype, "invoiceKind", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceKind'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateInvoice.prototype, "onInvoice_kind", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "normal",
    }),
    __metadata("design:type", String)
], CreateInvoice.prototype, "invoiceType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateInvoice.prototype, "onInvoice_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], CreateInvoice.prototype, "registerEntry", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('registerEntry'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateInvoice.prototype, "onRegister_entry", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], CreateInvoice.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateInvoice.prototype, "onSize", null);
CreateInvoice = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateInvoice);
exports.default = CreateInvoice;
vue_property_decorator_1.Vue.component("CreateInvoice", CreateInvoice);
